export const ADD_NOTE = "ADD_NOTE";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
export const SHOW_UPDATE_NOTE = "SHOW_UPDATE_NOTE";

export const CHANGE_DATE = "CHANGE_DATE";
export const SET_DATE = "SET_DATE";
